import BeniftContent from "../dao/BeniftContent";
import SingleProcessBlock from "./../../components/cryto-trading/SingleProcessBlock";

const HowItWorks = () => {
  return (
    <>
      {/* <!-- Process / CTA --> */}
      <section className="py-24 dark:bg-jacarta-800">
        <div className="container">
          <div className="mx-auto mb-12 text-center">
            <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-5xl text-center uppercase">
              HOW IT WORKS
            </h2>
            <p className="text-lg dark:text-jacarta-300">
              Our Impact Art campaigns are a great way to collaborate to raise
              funds with mutual benefits. Join a cause-driven community, support
              campaigns you care about, align with purposeful brands and
              influencers, and build an impact portfolio that benefits you and
              the planet.
            </p>
          </div>
          {/* End mx-auto */}

          <BeniftContent />

          {/* <CallToActions /> */}
        </div>
      </section>
      {/* <!-- end process / cta -->  */}
    </>
  );
};

export default HowItWorks;
